import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import Menu from "./Menu";
import Canvas from "./Canvas";
import theme from "./theme";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<Menu />} />
          <Route path="/create" element={<Canvas />} />
        </Routes>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);